module.exports = __webpack_public_path__ + "static/media/Artboard5.c27aeb87.png";